import React, { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Loader2, X } from "lucide-react";
import { uploadImage, mediaUrl } from "../media";
import { SecureImg } from "./SecureImg";

export const ImageUpload = ({ value, onChange, visibility = "public", label = "Foto ilustrativa", testid = "image-upload" }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    setBusy(true);
    try { onChange(await uploadImage(f, visibility)); toast.success("Foto enviada"); }
    catch (err) { toast.error(err.response?.data?.detail || "Falha ao enviar foto"); }
    finally { setBusy(false); }
  };

  return (
    <div className="space-y-1" data-testid={testid}>
      <p className="text-[10px] tracking-widest text-[color:var(--sun-700)] font-display">{label.toUpperCase()}</p>
      <div className="flex items-center gap-3">
        <div className="w-20 h-20 rounded-xl overflow-hidden border border-[var(--line)] bg-[var(--cream-100)] grid place-items-center shrink-0">
          {value ? (visibility === "private"
            ? <SecureImg src={value} alt="" className="w-full h-full object-cover"/>
            : <img src={mediaUrl(value)} alt="" className="w-full h-full object-cover"/>)
            : <ImagePlus size={20} className="text-[color:var(--ink-500)]"/>}
        </div>
        <div className="flex flex-col gap-1">
          <button type="button" onClick={() => ref.current?.click()} disabled={busy}
                  className="btn-ghost !py-1 !px-3 text-xs inline-flex items-center gap-1" data-testid={`${testid}-btn`}>
            {busy ? <Loader2 size={12} className="animate-spin"/> : <ImagePlus size={12}/>} {value ? "Trocar foto" : "Enviar foto"}
          </button>
          {value && <button type="button" onClick={() => onChange("")} className="text-xs text-[color:var(--danger)] inline-flex items-center gap-1" data-testid={`${testid}-remove`}><X size={12}/> Remover</button>}
        </div>
        <input ref={ref} type="file" accept="image/*" className="hidden" onChange={pick} data-testid={`${testid}-input`}/>
      </div>
    </div>
  );
};
